import { FC } from "react";
import { useApp } from "../context/useApp";
import { getZoneName, parseDate } from "../utils/helpers";
import { _ } from "../utils/helpers";

interface BookingContextProps {
    zone?: boolean
    shift?: boolean
    date?: boolean
    white?: boolean
    mobile?: boolean
    accesible?: boolean
}

export const BookingContext: FC<BookingContextProps> = ({date, shift, zone, white, mobile, accesible = true}) => {

    const {
        state: { booking }
    } = useApp()

    const zones = booking.getOccupiedZones()
    

    return (
        <section className="w-100 df aic" aria-label={accesible ? booking.getStringSummary() : undefined} aria-hidden={!accesible} >
            {date && booking.date !== '' && (
                <p className="text nw df fd-c aifs mr-10" aria-hidden>
                    <span className={`text ${white ? 'softest' : 'softer'} upper s14-500 caption`}>{_('0ge_date___')}</span>
                    <span className={`text ${mobile ? 's20-600' : 's24-600'} df ${white ? 'white' : ''}`}>{parseDate('d Nov \'yy', booking.date)}</span>
                </p>
            )}
            {shift && booking.shiftId !== 0 && (
                <p className="text upper nw df fd-c aifs mr-10" aria-hidden>
                    <span className={`text ${white ? 'softest' : 'softer'} s14-500 caption`}>{_('0ge_shift__')}</span>
                    <span className={`text ${mobile ? 's20-600' : 's24-600'} ${white ? 'white' : ''}`}>{parseDate('hh:mm', booking.date)}</span>
                </p>
            )}
            {zone && zones.length > 0 && (
                <p className="text upper nw df fd-c aifs" aria-hidden>
                    <span className={`text ${white ? 'softest' : 'softer'} s14-500 caption`}>{_('0ge_zone___')}</span>
                    <span className={`text ${mobile ? 's20-600' : 's24-600'} ${white ? 'white' : ''}`}>{zones.map(zone => getZoneName('short', zone, booking.journey)).join(',')}</span>
                </p>
            )}
        </section>
    )
}